import type { Enum } from './enum.types';
import type { Match, Team } from './match.types';

export const FormGuideOutcome = {
  WIN: 'WIN',
  DRAW: 'DRAW',
  LOSS: 'LOSS',
} as const;
export type FormGuideOutcome = Enum<typeof FormGuideOutcome>;

export type FormGuideMatch = {
  match: Match;
  outcome: FormGuideOutcome;
};

export type FormGuideTeam = {
  formguide: FormGuideMatch[];
  team: Team;
};

export type FormGuideResponse = {
  data: FormGuideTeam[];
};
